import { render, staticRenderFns } from "./20welcomQi.vue?vue&type=template&id=500763fd&scoped=true&"
import script from "./20welcomQi.vue?vue&type=script&lang=js&"
export * from "./20welcomQi.vue?vue&type=script&lang=js&"
import style0 from "./20welcomQi.vue?vue&type=style&index=0&id=500763fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500763fd",
  null
  
)

export default component.exports